var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_494_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7888 5.50488H4.50307C3.08291 5.50488 1.93164 6.72011 1.93164 8.21917V31.2906C1.93164 32.7897 3.08291 34.0049 4.50307 34.0049H32.7888C34.2089 34.0049 35.3602 32.7897 35.3602 31.2906V8.21917C35.3602 6.72011 34.2089 5.50488 32.7888 5.50488Z",
    stroke: "white",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.93164 8.89746L17.0002 22.4689C17.4623 22.8751 18.0446 23.0976 18.6459 23.0976C19.2473 23.0976 19.8296 22.8751 20.2916 22.4689L35.3602 8.89746",
    stroke: "white",
    strokeWidth: 1.99942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_494_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 38,
    fill: "white",
    transform: "translate(0.646484 0.754883)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.a1ba92db7cdeb4adf0066b324331ae4d.svg";
export { ForwardRef as ReactComponent };